import colors from '../../../../theme/foundations/colors'
import {fonts} from '../../../../theme/foundations/fonts'
import sizes from '../../../../theme/foundations/sizes'
import {pxToRem} from '../../../../utills/pxToRem'

export const wishlistItemBox = {
    '.inner-container': {
        width: '100%'
    },
    '.image-container': {
        width: [pxToRem(127), pxToRem(127), pxToRem(206), pxToRem(206)],
        height: [pxToRem(127), pxToRem(127), pxToRem(206), pxToRem(206)]
    },
    boxShadow: `${pxToRem(2)} ${pxToRem(4)} ${pxToRem(16.6)} ${pxToRem(2)} ${
        colors.blackAlpha[400]
    }`,
    paddingLeft: [pxToRem(15), pxToRem(15), pxToRem(15), pxToRem(18)],
    paddingRight: [pxToRem(15), pxToRem(15), pxToRem(15), pxToRem(18)],
    paddingBottom: [pxToRem(15), pxToRem(15), pxToRem(15), pxToRem(23)],
    paddingTop: [pxToRem(15), pxToRem(15), pxToRem(15), pxToRem(23)],
    marginRight: [
        `${pxToRem(11)} !important`,
        `${pxToRem(11)} !important`,
        `${pxToRem(11)} !important`,
        `${pxToRem(45)} !important`
    ],
    marginTop: [
        `${pxToRem(15)} !important`,
        `${pxToRem(15)} !important`,
        `${pxToRem(15)} !important`,
        `${pxToRem(25)} !important`
    ],
    marginLeft: [
        `${pxToRem(11)} !important`,
        `${pxToRem(11)} !important`,
        `${pxToRem(11)} !important`,
        '0px !important'
    ],
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    [`@media (max-width: ${sizes.container.md})`]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        overflow: 'hidden'
    }
}

// Container for the empty wishlist box
export const emptyWishlistContainer = {
    marginTop: [
        `${pxToRem(15)} !important`,
        `${pxToRem(15)} !important`,
        `${pxToRem(15)} !important`,
        `${pxToRem(25)} !important`
    ],
    marginRight: [
        `${pxToRem(11)} !important`,
        `${pxToRem(11)} !important`,
        `${pxToRem(11)} !important`,
        `${pxToRem(45)} !important`
    ],
    marginLeft: [
        `${pxToRem(11)} !important`,
        `${pxToRem(11)} !important`,
        `${pxToRem(11)} !important`,
        '0px !important'
    ],
    paddingLeft: [pxToRem(19), pxToRem(19), pxToRem(19), pxToRem(18)],
    paddingRight: [pxToRem(19), pxToRem(19), pxToRem(19), pxToRem(18)],
    paddingBottom: [pxToRem(15), pxToRem(15), pxToRem(15), pxToRem(23)],
    paddingTop: [pxToRem(15), pxToRem(15), pxToRem(15), pxToRem(23)],
    backgroundColor: 'white',
    boxShadow: `${pxToRem(2)} ${pxToRem(4)} ${pxToRem(16.6)} ${pxToRem(2)} ${
        colors.blackAlpha[400]
    }`,
    display: 'flex',
    flexDirection: 'column'
}

// Heading "NO WISHLIST ITEMS YET"
export const emptyWishlistHeading = {
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(16), pxToRem(16), pxToRem(16), pxToRem(18)],
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(2), pxToRem(2), pxToRem(2), pxToRem(3)],
    textTransform: 'uppercase',
    marginBottom: '0px',
    [`@media (max-width: ${sizes.container.xs})`]: {
        textAlign: 'center'
    }
}

// Description text content
export const emptyWishlistText = {
    marginBottom: '0px',
    marginTop: pxToRem(10),
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(12), pxToRem(13)],
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.xs})`]: {
        textAlign: 'center'
    }
}

// "SHOP NOW >>" button styling
export const emptyWishlistButton = {
    width: ['100x%', pxToRem(260), pxToRem(295), pxToRem(295)],
    marginTop: [pxToRem(20), pxToRem(20), pxToRem(20), pxToRem(25)],
    fontWeight: '700',
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(12), pxToRem(13)],
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5)
}

export const carouselStyle = {
    mt: [
        `${pxToRem(60)} !important`,
        `${pxToRem(60)} !important`,
        `${pxToRem(60)} !important`,
        `${pxToRem(80)} !important`
    ],
    padding: {base: '0 11px', lg: '0'},
    '> div': {
        '> div': {
            '> div:last-child': {
                padding: {base: '0 11px', lg: '0 45px 0 0'}
            }
        }
    }
}
